import { AbconetApi } from '../General/AbconetApi';

export class CartReorder extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isReordering: false,
            isReordered: false,
        }
    }

    reorderCart() {
        this.setState({ isReordering: true });

        var cart = this.props.initialState.cart;

        cart.lines = this.props.initialState.lines;
        cart.address = this.props.initialState.address;

        AbconetApi.post('/api/cart',cart).then(
            (cart) => {
                setTimeout(
                    () => {
                        this.setState({ isCreated: true, isCreating: false });

                        setTimeout(() => {
                            window.location = "/cart/" + cart.id;
                        },
                            300);
                    },
                    200);
            });
    }

    renderReorderButton() {
        var btnText = 'Reorder';
        var btnClass = 'changes';
        if (this.state.isReordered) {
            btnText = 'Reordered';
            btnClass = 'saved';
        }

        if (this.state.isReordering) {
            btnText = 'Reordering';
            btnClass = 'saving';
        }

        return <button className={"btn btn-secondary float-right mt-5 " + btnClass} disabled={this.state.isReordered || this.state.isReordering} onClick={this.reorderCart.bind(this)}>{btnText}</button>;
    }

    render() {

        return <div>
                {this.renderReorderButton()}
        </div>;
    }
}